import { dynamicLoader } from '~/utils';

export const SignOutButton = dynamicLoader({
  name: 'SignOutButton',
  importFunc: () => import('./sign-out-button'),
});